module.exports = __webpack_public_path__ + "static/6M_2024_Investor_Presentation_final_v2-c95fe641bfc67563e7387576414f83e0.pdf";